<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/wishlists/shared/basket-create-wishlist/basket-create-wishlist.component.ts
-->
<ng-template #anchor></ng-template>
